<template>
    <rkm-table
        :fields="fields"
        :items="data"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click="handleOpenModal(item)"
                color="info"
                small
                title="Observação"
            >
                <rkm-icon icon="info-circle" />
            </rkm-button>

            <rkm-button
                :disabled="!!item.allowDestroy"
                @click="destroy(item)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>

export default {
    data: () => ({
        fields: [
            { key: 'nome', label: 'Nome', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(causaProvavel) {

            this.showDeleteConfirmation(
                'Deseja realmente a causa provável?',
                async () => {this.data.splice(this.data.indexOf(causaProvavel), 1)}
            )
        },
        handleOpenModal(causaProvavel) {

            this.$emit('openModalObservacoes', causaProvavel)
        },
    },
    props: {
        data: { type: [Array, Object], required: true },
    },
}
</script>